/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InstanceSchema } from './InstanceSchema';
import {
    InstanceSchemaFromJSON,
    InstanceSchemaFromJSONTyped,
    InstanceSchemaToJSON,
} from './InstanceSchema';
import type { InstanceSpecSchema } from './InstanceSpecSchema';
import {
    InstanceSpecSchemaFromJSON,
    InstanceSpecSchemaFromJSONTyped,
    InstanceSpecSchemaToJSON,
} from './InstanceSpecSchema';
import type { ProcessStateSchema } from './ProcessStateSchema';
import {
    ProcessStateSchemaFromJSON,
    ProcessStateSchemaFromJSONTyped,
    ProcessStateSchemaToJSON,
} from './ProcessStateSchema';

/**
 * 
 * @export
 * @interface SchedulerSchema
 */
export interface SchedulerSchema {
    /**
     * 
     * @type {number}
     * @memberof SchedulerSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof SchedulerSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof SchedulerSchema
     */
    updated: Date;
    /**
     * 
     * @type {InstanceSpecSchema}
     * @memberof SchedulerSchema
     */
    spec: InstanceSpecSchema;
    /**
     * 
     * @type {string}
     * @memberof SchedulerSchema
     */
    name: string;
    /**
     * 
     * @type {InstanceSchema}
     * @memberof SchedulerSchema
     */
    instance?: InstanceSchema;
    /**
     * 
     * @type {ProcessStateSchema}
     * @memberof SchedulerSchema
     */
    currentState: ProcessStateSchema;
    /**
     * 
     * @type {string}
     * @memberof SchedulerSchema
     */
    dashboardAddress?: string;
}

/**
 * Check if a given object implements the SchedulerSchema interface.
 */
export function instanceOfSchedulerSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "spec" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "currentState" in value;

    return isInstance;
}

export function SchedulerSchemaFromJSON(json: any): SchedulerSchema {
    return SchedulerSchemaFromJSONTyped(json, false);
}

export function SchedulerSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): SchedulerSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'spec': InstanceSpecSchemaFromJSON(json['spec']),
        'name': json['name'],
        'instance': !exists(json, 'instance') ? undefined : InstanceSchemaFromJSON(json['instance']),
        'currentState': ProcessStateSchemaFromJSON(json['current_state']),
        'dashboardAddress': !exists(json, 'dashboard_address') ? undefined : json['dashboard_address'],
    };
}

export function SchedulerSchemaToJSON(value?: SchedulerSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'spec': InstanceSpecSchemaToJSON(value.spec),
        'name': value.name,
        'instance': InstanceSchemaToJSON(value.instance),
        'current_state': ProcessStateSchemaToJSON(value.currentState),
        'dashboard_address': value.dashboardAddress,
    };
}

